export default function nav() {
	
	$('#header .hamburger').on('click', function (e) {
		e.preventDefault();
		$( this ).toggleClass( 'is-active' );
		$( '.nav-container' ).toggleClass( 'active' );
		$( 'body' ).toggleClass( 'menu-open' );
  });
  
	$('.socials > ul > li > a').click(function(e){
		e.preventDefault();

		if (!$(this).parent().hasClass('active')) {
			$('.socials > ul > li').removeClass('active');
		}

		$(this).parent().addClass('active');
	});

	$('.socials .close-menu').click(function(e){
		e.preventDefault();
		$(this).parent().parent().parent().removeClass('active');
	});
}